import React from 'react'
import PropTypes from 'prop-types'

import { config } from '../../config.js'
import { getLegislation } from '../../util/legislation'
import { useAuth } from '../../providers/AuthProvider'
import BodyText from '../styles/Text'
import ConfirmationTemplate from '../common/ConfirmationTemplate'

const FOIConfirmation = ({ secondaryId }) => {
  const { authState } = useAuth()
  const legislation = getLegislation()
  const showLogo = !authState.accessToken

  return (
    <ConfirmationTemplate title={`${secondaryId} Submitted`} bodyText={[]} showLogo={showLogo} showContact={config.showContact}>
      <BodyText>Your request has been created.</BodyText>
      <BodyText>
        Applicable deadlines related to your request as per {legislation.name} will be confirmed by the City via official correspondence to follow.
      </BodyText>
    </ConfirmationTemplate>
  )
}

FOIConfirmation.propTypes = {
  secondaryId: PropTypes.string.isRequired
}

export default FOIConfirmation
